import { cn } from '@/lib/utils';

import { ButtonColors, ButtonVariants } from '@/components/atoms/button';
import { sharedStyles } from '@/components/atoms/input';

export const variantColors: {
  [key in ButtonVariants]: { [key in ButtonColors]: string };
} = {
  filled: {
    primary: 'text-neutral-dark-N00 bg-primary-P99 hover:bg-primary-P50',
    secondary: 'text-neutral-N00 bg-neutral-N99 hover:bg-neutral-N80',
    tertiary: 'text-neutral-N99 bg-neutral-N00 hover:bg-neutral-N10',
    neutral: 'text-neutral-N99 bg-neutral-N00 hover:bg-neutral-N10', //currently the same as tertiary, update when new styling will be created
  },
  outlined: {
    primary:
      'text-primary-P99 bg-transparent border-primary-P99 border boder-solid hover:shadow-border-px hover:shadow-primary-P99',
    secondary:
      'text-neutral-N99 bg-transparent border-neutral-N99 border boder-solid hover:shadow-border-px hover:shadow-neutral-N99',
    tertiary:
      'text-neutral-N00 bg-transparent border-neutral-N00 border boder-solid hover:shadow-border-px hover:shadow-neutral-N00',
    neutral:
      'text-neutral-N00 bg-transparent border-neutral-N00 border boder-solid hover:shadow-border-px hover:shadow-neutral-N00', //currently the same as tertiary, update when new styling will be created
  },
  text: {
    primary: 'text-primary-P99 bg-transparent font-sans',
    secondary: 'text-neutral-N99 bg-transparent font-sans',
    tertiary: 'text-neutral-N00 bg-transparent font-sans',
    neutral:
      'text-neutral-N40 hover:text-neutral-N00 dark:hover:text-neutral-dark-N00 bg-transparent font-sans',
  },
  input: {
    primary: cn('hover:shadow-none justify-start', sharedStyles),
    secondary: cn('hover:shadow-none justify-start', sharedStyles),
    tertiary: cn('hover:shadow-none justify-start', sharedStyles),
    neutral: cn('hover:shadow-none justify-start', sharedStyles),
  },
} as const;
